import app from './app/app.js'

import mediaQueries from './helpers/media-queries.js'

import AccordionComponent from './components/accordion'
import EventsBarComponent from './components/eventsbar'
import PostsGridComponent from './components/postsgrid'
import PostsSliderComponent from './components/postsslider'
import TopComponent from './components/top'
import MapComponent from './components/map'
import ScrollUpComponent from './components/scrollup'
import MobileMenuComponent from './components/mobilemenu'

import reveal from './helpers/reveal.js'

app
  .addComponent('accordion', AccordionComponent)
  .addComponent('eventsbar', EventsBarComponent)
  .addComponent('map', MapComponent)
  .addComponent('postsgrid', PostsGridComponent)
  .addComponent('postsslider', PostsSliderComponent)
  .addComponent('top', TopComponent)
  .addComponent('scrollup', ScrollUpComponent)
  .addComponent('mobilemenu', MobileMenuComponent)
  .init()

// media queries
mediaQueries.add('medium', '(min-width: 761px) and (max-width: 1100px)')
mediaQueries.add('small', '(max-width: 760px)')

// reveal
reveal.init()

// event emitter
document.eventEmit = function(eventName, eventParams = {}) {
  document.dispatchEvent(
    new CustomEvent(eventName),
    { detail: eventParams }
  )
}
